module.exports = "/_next/static/images/namecoin-23969edcb12fb8a6ad0f84c7a7221ccf.png";